import { Component, Inject } from '@angular/core';
import { ClientManagerInstanceToken, ClientManagerInterface } from '@evorait/pace-core';

@Component({
    selector: 'pace-authors-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    public appVersion = '';
    public constructor(@Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface) {
        this.appVersion = this.clientManager.getAppVersion();
    }
}
